<script>
  export let settings;
  export let recs;
 
  import { Button, Card, Table } from 'sveltestrap';
  import { from } from './from.js';
  import QuickDropRec from './QuickDropRec.svelte';
  import { global } from './state.js'
  import { addEphemeralRec, createRecFromUrls } from './recs.js'

  let summary = {};
  
  if (global.bootRec) {
    // console.log("Dashboard - bootRec", global.bootRec)
    // if (!global.bootRec.a) {
    //   global.bootRec.a = { columns: [] , name: "Left",  stamp: "Current" }
    //   global.bootRec.b = { columns: [] , name: "Right", stamp: "Current" }
    // }
    // addEphemeralRec(global.bootRec);
    createRecFromUrls(global.bootRec)
  } else if (!global.noauth) {
    summary = {
      name: "Jimmy Blue",
      recents : []
    };
    from("/dashboard", {}).then(r=>r.json()).then(obj=>{
      summary = obj;
    })
    .catch(ex => {
      console.error("dashboard - ex - ",ex, ex.stack);
    });
  }
  // $: { console.log("==================recs", $recs) }


</script>

<div class="row pt-2">
  {#if !global.bootRec}
  <div class="col-sm-3">
    <Card body>
      <div>User:            {summary.name}</div> 
      <div>Last login:      {summary.lastLogin}</div>
      <div>Data sources:    {(($settings || {}).data || []).length}</div>
      <div>Recs configured: {(($recs     || {}).list || []).length}</div>
<!--
      <div>Recent recs:</div>
      <ul>
        {#each summary.recents as rec }
        <li>(<span title="{rec.exactly}">{rec.when}</span>) : {rec.name} : {rec.full} / {rec.partial} / {rec.non}</li>
        {/each}
      </ul>
-->
    </Card>

<!--
    <Card body>
      <Button on:click={createRec}>Create a reconciliation</Button>
    </Card>
-->
  </div>
  {/if}

  <div class="col-sm">
<!--
    Task list , current user / admin scope view 
    <Table>
      <tr>
        <td>Rec</td>
        <td>User</td>
        <td>Item</td>
        <td>Age</td>
        <td>Action</td>
      </tr>
      <tr>
        <td>AccountsRec</td>
        <td>Sarah Red</td>
        <td>Missing bank entry</td>
        <td>1 hour</td>
        <td>
          <Button>Escalate</Button>
          <Button>Ack</Button>
          <Button>Ignore</Button>
        </td>
      </tr>
    </Table>
-->

    <QuickDropRec class="col-6" />
    <Card body class="col-6">
     <p>New here? Let's get started.</p>
     <p> The quickest route is to select the two files you want to compare on 
     your computer and drag them on to the dashed area next to these instructions.
     </p>
     <p> This will upload each file, creating a <a href="#">data source</a> for each one,
     and then will create run a reconciliation of the two files, which will highlight 
     matching and non-matching rows.
     </p>

    </Card>
  </div>


</div>
